import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Button, Carousel, Fade, Container, Row, Col, Card} from 'react-bootstrap';
import {Redirect} from 'react-router-dom';
import CommonMetaTag from './common-meta-tag';
import Configuration from '../config';
import {useTranslation} from 'react-i18next';
import {FaCalendarAlt, FaChevronRight, FaPlus} from 'react-icons/fa';

const PartnerEvents = ({
  isLogged,
  ownedEvents,
  newEvent,
  showEvent
}) => {
  const {t, i18n} = useTranslation();
  if (!isLogged) {
    return (
      <Redirect to="/login"/>
    );
  }

  return (
    <Fragment>
      <CommonMetaTag/>
      <Fade in appear style={{transition: 'opacity 0.30s linear'}}>
        <main className="partner-events-page">
        <Container>
          <section className="partner-events-hero">
            <div>
              <span className="partner-events-eyebrow">{t('SPECIAL_EVENTS_MANAGEMENT')}</span>
              <h1>{t('SPECIAL_EVENTS')}</h1>
              <p>{t('SPECIAL_EVENTS_INTRO')}</p>
            </div>
            <Button className="partner-events-primary-button" onClick={() => newEvent()}><FaPlus/>{t('CREATE_SPECIAL_EVENT')}</Button>
          </section>
          <Row className="partner-events-grid">
                {
                  ownedEvents.map(e =>
                    (
                      <Col key={e.id} xs={12} sm={12} md={12} xl={6} lg={6}>
                        <Card className="partner-event-card">
                          <Card.Body>
                          <div className="partner-event-card-media">
                          {
                            (e.imageName || []).length === 0 ?
                              <div className="partner-event-card-placeholder"><FaCalendarAlt/></div> :
                              <Carousel interval={null}>
                                {
                                  (e.imageName || []).map(i =>
                                    (
                                      <Carousel.Item key={i}>
                                        <img
                                          className="d-block w-100"
                                          src={`${Configuration.apiEndPoint}/partners/events/${e.id}/images?load=${i}`}
                                          alt={t('FIRST_SLIDE')}
                                        />
                                      </Carousel.Item>
                                    )
                                  )
                                }
                              </Carousel>
                            }
                            </div>
                            <div className="partner-event-card-content">
                            <Card.Title>
                              {e.title}
                            </Card.Title>
                            <Card.Text className="partner-event-card-description">
                              {e.description}
                            </Card.Text>
                            <Card.Text className="partner-event-card-date"><FaCalendarAlt/>
                             {t('SPECIAL_EVENT_DATES', {start_date: new Date(e.startDatetime).toLocaleDateString(i18n.language, {year: 'numeric', month: 'numeric', day: 'numeric'}), end_date: new Date(e.endDatetime).toLocaleDateString(i18n.language, {year: 'numeric', month: 'numeric', day: 'numeric'})})}
                            </Card.Text>
                            <Button className="partner-events-secondary-button" onClick={showEvent(e)}>{t('CHANGE')}<FaChevronRight/></Button>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    )
                  )
                }
                {ownedEvents.length === 0 ? <Col xs={12}><div className="partner-events-empty"><FaCalendarAlt/><h3>{t('NO_SPECIAL_EVENTS')}</h3><p>{t('SPECIAL_EVENTS_EMPTY_DESC')}</p></div></Col> : null}
              </Row>
        </Container>
        </main>
      </Fade>
    </Fragment>
  );
};

PartnerEvents.propTypes = {
  ownedEvents: PropTypes.array,
  isLogged: PropTypes.bool,
  newEvent: PropTypes.func.isRequired,
  showEvent: PropTypes.func.isRequired,
};

PartnerEvents.defaultProps = {
  ownedEvents: [],
  isLogged: false
};

export default PartnerEvents;
